import { render, staticRenderFns } from "./RTCVideoRecorder.vue?vue&type=template&id=194a0065"
import script from "./RTCVideoRecorder.vue?vue&type=script&lang=ts"
export * from "./RTCVideoRecorder.vue?vue&type=script&lang=ts"
import style0 from "./RTCVideoRecorder.vue?vue&type=style&index=0&id=194a0065&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports